/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class DonationsRoute extends Route {
  // Services
  @service
  store;

  model() {
    let financeModel = this.modelFor('people.person.finance');
    let personIds = JSON.stringify(financeModel.personIds);

    return hash({
      person: financeModel.person,
      accounts: this.store.query('finance/account', { personIds }),
      items: this.store.query('finance/line-item', {
        learnerIds: personIds,
        donationOnly: true,
      }),
      transactions: this.store.query('finance/transaction', {
        learnerIds: personIds,
        donationOnly: true,
        include: 'sourceTransactions',
      }),
    });
  }
}
